import { Component, Input, OnInit } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { eAuthTooltipText, navRouteConstants } from '../../../shared/utilities/Constants';
import { Customers } from '../../models/AccountInfoApiResponse';
import { Eauthorization } from '../../models/Eauthorization';
import { Store } from "@ngrx/store";
import { ContextService } from 'projects/integration/src/app/context.service';
import { CoreService } from '@charlesschwab/sac-ui-core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'mm-eauth',
  templateUrl: './eauth.component.html',
  styleUrls: ['./eauth.component.scss']  
})
export class EauthComponent implements OnInit {
  @Input() eAuthorization$: Observable<Eauthorization>;
  eAuthorization: Eauthorization | null;
  pendingSetupText: string = eAuthTooltipText.pendingSetupVerbiage;
  missingEmailText: string = eAuthTooltipText.missingEmailVerbiage;
  greenIndicator: boolean;
  eAuthAddLink: string = eAuthTooltipText.addEditEmailLink;
  eAuthTooltipText: string;
  destroy$ = new Subject<void>();

  constructor(private store: Store, private contextService: ContextService,private router: Router, private coreService: CoreService) { }

  ngOnInit(): void {
    this.eAuthorization$.pipe(takeUntil(this.destroy$)).subscribe((eAuth) => {
      this.eAuthorization = eAuth;
      if (this.isEauthEligibleAccount) {
        if (this.someAccountHoldersEligible) {
          this.eAuthTooltipText = eAuthTooltipText.accountHoldersEligible;
          this.eAuthAddLink = eAuthTooltipText.addEditEmailLink;
        } else {
          if (
            this.pendingCustomers.length === 0 ||
            this.cannotDisplayAnyAccountHolders
          ) {
            this.eAuthAddLink = eAuthTooltipText.addAccountHolderLink;
            this.eAuthTooltipText = eAuthTooltipText.noneAccountHoldersEligible;
          }
        }
      } else {
        this.eAuthTooltipText = eAuthTooltipText.accountIneligible;
      }
    });
  }

  routeReturned() {
    const currentUrl: string = window.location.href;
      if (this.contextService.isMonolithUrl(currentUrl)) { 
        this.router.navigate([navRouteConstants.setupEAuth])
      }
      else
      {
        let encodedContext = decodeURIComponent(this.coreService.currentContext.encodedContext as string);
        this.router.navigate([navRouteConstants.setupEAuth], { queryParams: { ec: encodedContext } });
      }
  }

  get isEauthEligibleAccount() {
    return !this.eAuthorization?.isAccountRestricted;
  }

  get customers() {
    return this.eAuthorization?.customers ?? [];
  }

  get pendingCustomers(): Customers[] {
    return this.customers.filter(
      (customer) => !customer.isCustomerWebEnrolled && !!customer.emailId
    );
  }

  get eligibleCustomers(): Customers[] {
    return this.customers.filter(
      (customer) => customer.isEauthEligible && customer.isCustomerWebEnrolled
    );
  }

  get displayAddHyperLink(): boolean {
    return (
      this.isEauthEligibleAccount &&
      !(
        this.eligibleCustomers.length === 0 && this.pendingCustomers.length > 0
      )
    );
  }

  get someAccountHoldersEligible(): boolean {
    return this.customers.some(
      (customer) => customer.isEauthEligible && customer.isCustomerWebEnrolled
    );
  }

  get missingEmailAddress(): boolean {
    return (
      this.isEauthEligibleAccount &&
      this.customers.some((customer) => !customer.emailId)
    );
  }

  get requiresEAuthSetup(): boolean {
    return (
      this.isEauthEligibleAccount &&
      this.eligibleCustomers.length === 0 &&
      this.pendingCustomers.length === 0
    );
  }

  get cannotDisplayAnyAccountHolders(): boolean {
    if (this.customers.length <= 0) {
      return true;
    }

    for (var i = 0; i < this.customers.length; i++) {
      if (this.customers[i].displayIndicator) {
        return false;
      }
    }
    return true;
  }
}
